import { Text, Select, Box, Loader } from '@mantine/core';
import { getRerenrollmentStatus } from '../../utils/utils';
import { apiInstance } from '../../services/api_service';
import { useState } from 'react';

const ReenrollmentStatus = ({ row, onStatusUpdate }) => {
  const [value, setValue] = useState(row.original.reenrollment_status?.status || 'not-done');
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null); // null, 'success', or 'error'

  const statusOptions = [
    { value: 'not-done', label: getRerenrollmentStatus('not-done') },
    { value: 'will-do', label: getRerenrollmentStatus('will-do') },
    { value: 'will-not-do', label: getRerenrollmentStatus('will-not-do') },
    { value: 'maybe', label: getRerenrollmentStatus('maybe') },
    { value: 'under-negotiation', label: getRerenrollmentStatus('under-negotiation') }
  ];

  const handleStatusChange = async (newValue) => {
    const currentValue = value;
    setIsLoading(true);
    setStatus(null);
    try {
      setValue(newValue);
      await apiInstance.put(`students/waiting-reenrollment/${row.original.id}/reenrollment-status/`, {
        id: row.original.reenrollment_status.id,
        status: newValue
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      onStatusUpdate(row.original.id, newValue);
      setStatus('success');
    } catch (error) {
      console.error('Error updating reenrollment status:', error);
      setStatus('error');
      setValue(currentValue);
    } finally {
      setIsLoading(false);
      setTimeout(() => {
        setStatus(null);
      }, 3000);
    }
  };

  const renderStatusMessage = () => {
    if (isLoading) {
      return <Loader size="sm" />;
    }
    if (status === 'success') {
      return <Text color="green" size="sm">Alterado com sucesso</Text>;
    }
    if (status === 'error') {
      return <Text color="red" size="sm">Falha na alteração</Text>;
    }
    return null;
  };

  return (
    <Box style={{ 
      marginTop: 20,
      display: 'flex',
      alignItems: 'center'
    }}>
      <Text weight={500} style={{ marginBottom: 6, marginRight: 5 }}>
        Intenção de rematrícula:
      </Text>
      <Select
        data={statusOptions}
        value={value}
        onChange={handleStatusChange}
        style={{ width: 200 }}
      />
      <Box style={{ marginLeft: 10, minWidth: 150 }}>
        {renderStatusMessage()}
      </Box>
    </Box>
  );
};

export default ReenrollmentStatus;